import db from "../../../../database";
import { v4 as uuidv4 } from "uuid";
import useAuthStore from "../../../../stores/useAuthStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useCartStore from "../../../../stores/useCartStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import { applyCurrencyRounding, getRoundingMethod } from "../../../../utils/tillHelpers";

export const TotalBillFreeProductDiscount = async (
  pricingRule,
  setCart,
  cart,
  orderType,
  cartObj,
  addProduct,
  setOfferProductList,
  setDisplayOfferProductSelection,
  iscoupon,
  couponInput,
  uniqReferenceId,
  mPricingCouponId,
  mPricingRulesId
) => {
  const isExchange = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
  const saleTypeValidation = pricingRule.cwrSaletypeId === null ? true : pricingRule.cwrSaletypeId === orderType.cwrSaletype.cwrSaletypeId;
  const billCart = { ...cartObj };
  const tillData = useAuthStore.getState().tillData;

  let categoryItems = [];
  let brandItems = [];
  billCart.items.map((item) => {
    const stateValidation = pricingRule.mPricingXProducts.some((pc) => pc.mProductId === item.productId);
    const brandValidation = pricingRule.mPricingBrands.some((pc) => pc.mBrandId === item.productBrandId);
    const categoryValidation = pricingRule.mPricingPcategories.some((pc) => pc.mProductCategoryId === item.mProductCategoryId);
    if (stateValidation) {
      brandItems.push(item);
    }
    if (brandValidation) {
      brandItems.push(item);
    }
    if (categoryValidation) {
      categoryItems.push(item);
    }
    return null;
  });

  let allItems = [...brandItems, ...categoryItems];
  let uniqueFinalArray = [...new Set(allItems)];
  let flag = brandItems.length > 0 ? true : categoryItems.length > 0 ? true : false;

  if (saleTypeValidation) {
    let maxBillAmountFlag = pricingRule.maxBillAmount ? billCart.total <= pricingRule.maxBillAmount : true;
    const minQtyFlag = pricingRule.minimumQty ? cartObj.totalQty >= pricingRule.minimumQty : true;
    const maxQtyFlag = pricingRule.maximumQty ? cartObj.totalQty <= pricingRule.maximumQty : true;
    const minAmountFlag = pricingRule.billAmount ? cartObj.total >= pricingRule.billAmount : true;
    const maxAmountFlag = pricingRule.maxBillAmount ? cartObj.total <= pricingRule.maxBillAmount : true;
    let totalPrice = 0;
    let excludingFlag = true;

    if (pricingRule.mPricingB2CCustomerSegments.length > 0) {
      const matchingCustomerSegment = pricingRule.mPricingB2CCustomerSegments.find(
        (pc) => pc.cwrB2CCustomerSegmentId === cartObj.customer?.b2cCustomerSegment?.cwrB2CCustomerSegmentId
      );

      if (
        (pricingRule.excludeB2CSegment === "Y" && matchingCustomerSegment) ||
        (pricingRule.excludeB2CSegment !== "Y" && !matchingCustomerSegment && pricingRule.mPricingB2CCustomerSegments.length > 0) ||
        (pricingRule.excludeB2CSegment === "N" && pricingRule.mPricingB2CCustomerSegments.length === 0)
      ) {
        excludingFlag = false;
      }
    }

    if (pricingRule.mPricingB2CCustomers.length > 0) {
      const matchingCustomer = pricingRule.mPricingB2CCustomers.find((pc) => pc.b2cCustomerId === cartObj.customer.cwrCustomerId);

      if (
        (pricingRule.excludeB2CCustomers === "Y" && matchingCustomer) ||
        (pricingRule.excludeB2CCustomers !== "Y" && !matchingCustomer && pricingRule.mPricingB2CCustomers.length > 0) ||
        (pricingRule.excludeB2CCustomers === "N" && pricingRule.mPricingB2CCustomers.length === 0)
      ) {
        excludingFlag = false;
      }
    }
    cartObj.items.map((product) => (totalPrice = totalPrice + product.nettotal));
    if (totalPrice >= pricingRule.billAmount && maxBillAmountFlag && minQtyFlag && maxQtyFlag && minAmountFlag && maxAmountFlag) {
      if (pricingRule.mPricingXProducts.length > 0) {
        if (pricingRule.mPricingXProducts.length === 1) {
          await db.products
            .where("mProductId")
            .equalsIgnoreCase(pricingRule.mPricingXProducts[0].mProductId)
            .toArray()
            .then((allProducts) => allProducts.filter((p) => p.isactive == true))
            .then((product) => {
              if (product.length > 0) {
                const obj = { ...product[0] };
                let batchno = null;
                let mBatchId = null;
                let upc = null;
                if (obj.batchedProduct === "Y" && obj.batchedForSale === "Y") {
                  const bI = obj.mBatch.findIndex((p) => p.mBatchId === pricingRule.mPricingXProducts[0].mBatchId);
                  batchno = obj.mBatch[bI].batchno;
                  mBatchId = obj.mBatch[bI].mBatchId;
                  upc = obj.mBatch[bI].upc;
                }
                if (obj.overRideTax === "Y" && 0 <= obj.overRideCondition) {
                  obj.cTaxId = obj.contraTaxId;
                  obj.taxRate = obj.contraRate;
                }
                const productDefined = {
                  batchno: batchno,
                  description: obj.description,
                  discount: 0,
                  discountName: "",
                  lineId: uuidv4().replace(/-/g, "").toUpperCase(),
                  imageurl: obj.imageurl,
                  isDecimal: obj.isDecimal,
                  isManualQty: obj.isManualQty,
                  restrictPosQtyEdit: obj.restrictPosQtyEdit || "N",
                  showAlternateUomInPos: obj?.showAlternateUomInPos || "N",
                  interTaxId: obj?.interTaxId || "",
                  interTaxRate: obj?.interTaxRate || 0,
                  interTaxName: obj?.interTaxName || "",
                  alternateUom: obj?.alternateUom || null,
                  companion: obj?.companion || "N",
                  isPromoApplicable: false,
                  isReturn: false,
                  mBatchId: mBatchId,
                  mPricingruleId: null,
                  name: obj.name,
                  nettotal: 0,
                  primaryOrderLine: null,
                  productId: obj.mProductId,
                  realPrice: 0,
                  listPrice: 0,
                  returnQty: null,
                  salePrice: 0,
                  stock: obj.onhandQty,
                  tax: obj.cTaxId,
                  taxAmount: 0,
                  taxRate: obj.taxRate,
                  uom: obj.csUomId,
                  uom_name: obj.uomName,
                  isDecimalQty: obj.uomData?.[0]?.decimal === "Y" ? true : false,
                  isQtyDesimal: obj.uomData?.[0]?.stdprecision ?? 2,
                  upc: upc,
                  value: obj.value,
                  weight: 1,
                  shortDescription: obj.shortDescription,
                  hsncode: obj.hsncode,
                  csBunitId: obj.csBunitId,
                  mProductCategoryId: obj.mProductCategoryId,
                  productManufacturerId: obj.productManufacturerId,
                  productBrandId: obj.productBrandId,
                  productBrandName: obj?.productBrandName,
                  batchedProduct: obj.batchedProduct,
                  batchedForSale: obj.batchedForSale,
                  batchedForStock: obj.batchedForStock,
                  multiPrice: obj.multiPrice,
                  shelfLife: obj.shelfLife,
                };
                let productIndex = cartObj.items.findIndex((pc) => pc.productId === obj.mProductId);
                const matchingProductIndex = pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === obj.mProductId);

                if (
                  (pricingRule.excludeProducts === "Y" && matchingProductIndex !== -1) ||
                  (pricingRule.excludeProducts !== "Y" && matchingProductIndex === -1 && pricingRule.mPricingXProducts.length > 0) ||
                  (pricingRule.excludeProducts === "N" && pricingRule.mPricingXProducts.length === 0)
                ) {
                  excludingFlag = false;
                }

                const matchingBrand = pricingRule.mPricingBrands.find((pc) => pc.mBrandId === obj.productBrandId);

                if (
                  (pricingRule.excludeBrands === "Y" && matchingBrand) ||
                  (pricingRule.excludeBrands !== "Y" && !matchingBrand && pricingRule.mPricingBrands.length > 0) ||
                  (pricingRule.excludeBrands === "N" && pricingRule.mPricingBrands.length === 0)
                ) {
                  excludingFlag = false;
                }

                const matchingBusinessUnit = pricingRule.mPricingBUnits.find((pc) => pc.mBunitPricingId === tillData.tillAccess.csBunit.csBunitId);
                if (
                  (pricingRule.excludeBusinessUnits === "Y" && matchingBusinessUnit) ||
                  (pricingRule.excludeBusinessUnits !== "Y" && !matchingBusinessUnit && pricingRule.mPricingBUnits.length > 0) ||
                  (pricingRule.excludeBusinessUnits === "N" && pricingRule.mPricingBUnits.length === 0)
                ) {
                  excludingFlag = false;
                }

                const matchingCategoy = pricingRule.mPricingPcategories.find((pc) => pc.mProductCategoryId === obj.mProductCategoryId);

                if (
                  (pricingRule.excludeProductCategories === "Y" && matchingCategoy) ||
                  (pricingRule.excludeProductCategories !== "Y" && !matchingCategoy && pricingRule.mPricingPcategories.length > 0) ||
                  (pricingRule.excludeProductCategories === "N" && pricingRule.mPricingPcategories.length === 0)
                ) {
                  excludingFlag = false;
                }

                if (productIndex < 0 && excludingFlag) {
                  addProduct(productDefined, 1);
                }
              }
            });
        } else {
          const offerProductsStack = [];
          const updatedItems = cart.items.map(item => ({ ...item }));
          for (let i = 0; i < pricingRule.mPricingXProducts.length; i++) {
            await db.products
              .where("mProductId")
              .equalsIgnoreCase(pricingRule.mPricingXProducts[i].mProductId)
              .toArray()
              .then((allProducts) => allProducts.filter((p) => p.isactive == true))
              .then((product) => {
                if (product.length > 0 && pricingRule.mPricingXProducts[i].isFree === "Y") {
                  const obj = { ...product[0] };
                  let batchno = null;
                  let mBatchId = null;
                  let upc = null;
                  if (obj.batchedProduct === "Y" && obj.batchedForSale === "Y") {
                    const bI = obj.mBatch.findIndex((p) => p.mBatchId === pricingRule.mPricingXProducts[i].mBatchId);
                    if (bI >= 0) {
                      batchno = obj.mBatch[bI].batchno;
                      mBatchId = obj.mBatch[bI].mBatchId;
                      upc = obj.mBatch[bI].upc;
                    }
                  }
                  if (obj.overRideTax === "Y" && 0 <= obj.overRideCondition) {
                    obj.cTaxId = obj.contraTaxId;
                    obj.taxRate = obj.contraRate;
                  }
                  const productDefined = {
                    batchno: batchno,
                    description: obj.description,
                    lineId: uuidv4().replace(/-/g, "").toUpperCase(),
                    discount: 0,
                    discountName: "",
                    imageurl: obj.imageurl,
                    isDecimal: obj.isDecimal,
                    isManualQty: obj.isManualQty,
                    restrictPosQtyEdit: obj.restrictPosQtyEdit || "N",
                    showAlternateUomInPos: obj?.showAlternateUomInPos || "N",
                    interTaxId: obj?.interTaxId || "",
                    interTaxRate: obj?.interTaxRate || 0,
                    interTaxName: obj?.interTaxName || "",
                    alternateUom: obj?.alternateUom || null,
                    companion: obj?.companion || "N",
                    isReturn: false,
                    isPromoApplicable: false,
                    mBatchId: mBatchId,
                    mPricingruleId: null,
                    name: obj.name,
                    nettotal: 0,
                    primaryOrderLine: null,
                    productId: obj.mProductId,
                    realPrice: 0,
                    listPrice: 0,
                    returnQty: null,
                    salePrice: 0,
                    stock: obj.onhandQty,
                    tax: obj.cTaxId,
                    taxAmount: 0,
                    taxRate: obj.taxRate,
                    uom: obj.csUomId,
                    uom_name: obj.uomName,
                    isDecimalQty: obj.uomData?.[0]?.decimal === "Y" ? true : false,
                    isQtyDesimal: obj.uomData?.[0]?.stdprecision ?? 2,
                    upc: upc,
                    value: obj.value,
                    weight: 1,
                    shortDescription: obj.shortDescription,
                    hsncode: obj.hsncode,
                    csBunitId: obj.csBunitId,
                    mProductCategoryId: obj.mProductCategoryId,
                    productManufacturerId: obj.productManufacturerId,
                    productBrandId: obj.productBrandId,
                    productBrandName: obj?.productBrandName,
                    batchedProduct: obj.batchedProduct,
                    batchedForSale: obj.batchedForSale,
                    batchedForStock: obj.batchedForStock,
                    multiPrice: obj.multiPrice,
                    shelfLife: obj.shelfLife,
                    iscoupon: iscoupon,
                    mPricingruleId: pricingRule.mPricingrulesId,
                  };
                  let productIndex = cartObj.items.findIndex((pc) => pc.productId === obj.mProductId);
                  const matchingProductIndex = pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === obj.mProductId);

                  if (
                    (pricingRule.excludeProducts === "Y" && matchingProductIndex !== -1) ||
                    (pricingRule.excludeProducts !== "Y" && matchingProductIndex === -1 && pricingRule.mPricingXProducts.length > 0) ||
                  (pricingRule.excludeProducts === "N" && pricingRule.mPricingXProducts.length === 0)
                  ) {
                    excludingFlag = false;
                  }

                  const matchingBrand = pricingRule.mPricingBrands.find((pc) => pc.mBrandId === obj.productBrandId);

                  if (
                  (pricingRule.excludeBrands === "Y" && matchingBrand) ||
                  (pricingRule.excludeBrands !== "Y" && !matchingBrand && pricingRule.mPricingBrands.length > 0) ||
                  (pricingRule.excludeBrands === "N" && pricingRule.mPricingBrands.length === 0)
                ) {
                    excludingFlag = false;
                  }

                  const matchingBusinessUnit = pricingRule.mPricingBUnits.find((pc) => pc.mBunitPricingId === tillData.tillAccess.csBunit.csBunitId);
                  if (
                    (pricingRule.excludeBusinessUnits === "Y" && matchingBusinessUnit) ||
                    (pricingRule.excludeBusinessUnits !== "Y" && !matchingBusinessUnit && pricingRule.mPricingBUnits.length > 0) ||
                  (pricingRule.excludeBusinessUnits === "N" && pricingRule.mPricingBUnits.length === 0)
                  ) {
                    excludingFlag = false;
                  }

                  const matchingCategoy = pricingRule.mPricingPcategories.find((pc) => pc.mProductCategoryId === obj.mProductCategoryId);

                  if (
                    (pricingRule.excludeProductCategories === "Y" && matchingCategoy) ||
                    (pricingRule.excludeProductCategories !== "Y" && !matchingCategoy && pricingRule.mPricingPcategories.length > 0) ||
                  (pricingRule.excludeProductCategories === "N" && pricingRule.mPricingPcategories.length === 0)
                  ) {
                    excludingFlag = false;
                  }

                  if (excludingFlag) {
                    if (productIndex >= 0) {
                      let weight = updatedItems[productIndex]?.weight;
                      updatedItems[productIndex] = { ...productDefined, weight, isFree: true };
                    } else {
                      offerProductsStack.push(productDefined);
                    }
                  }
                }
              });
          }

          // setTimeout(() => {
          let totalTax = 0;
          let totalPrice = 0;
          let totalItemsQty = 0;
          let totalDiscounts = 0;
          for (let i = 0; i < updatedItems.length; i += 1) {
            totalPrice += updatedItems[i].nettotal;
            totalItemsQty += updatedItems[i].weight;
            totalTax += updatedItems[i].taxAmount;
            totalDiscounts += updatedItems[i].discount;
            updatedItems[i].key = i;
          }

          const { roundedTotal: roundOffValue, roundOffAmount: totalRoundOff } = applyCurrencyRounding(totalPrice, getRoundingMethod(tillData));

          let couponsData = cart.couponInput.length > 0 ? [...cart.couponInput] : [];
          if (offerProductsStack.length > 0) {
            if (!couponsData.some((coupon) => coupon.couponCode === couponInput) && couponInput !== undefined && couponInput !== null) {
              couponsData.push({ couponCode: couponInput, referenceId: uniqReferenceId, mPricingCouponId: mPricingCouponId, mPricingruleId: mPricingRulesId });
            }
            setOfferProductList([...offerProductsStack]);
          } else {
            setOfferProductList([]);
          }
          const updatedCart = {
            ...cart,
            items: updatedItems,
            couponInput: couponsData,
            iscoupon: cart.iscoupon ? cart.iscoupon : false,
            mPricingrulesId: pricingRule.mPricingrulesId,
            totalBillDicount: pricingRule.mPricingrulesId,
            discountType: "TDF",
            total: totalPrice,
            tax: totalTax,
            discount: totalDiscounts,
            totalQty: totalItemsQty,
            roundOff: totalRoundOff,
            saleType: usePOSConfigStore.getState().saleTypeData?.cwrSaletype || {},
          };
          if (isExchange) {
            useCartStore.getState().setExchangeCart({ ...updatedCart });
          } else {
            setCart(updatedCart);
          }

          return updatedCart;
        }
      }
    }
  }
};
